import type { ComponentProps, ReactNode } from 'react';
import { PluginWorkbenchContext } from '@/features/plugins/use-plugin-workbench';
import {
  type ConversationOpener,
  ConversationOpenerContext,
} from '@/lib/desktop-shell/conversation-opener';
import { DesktopShellStoreProvider } from '@/lib/desktop-shell/store-context';

export function ConversationProviders({
  opener,
  store,
  workbench,
  children,
}: {
  opener: ConversationOpener;
  store: ComponentProps<typeof DesktopShellStoreProvider>['store'];
  workbench: ComponentProps<typeof PluginWorkbenchContext>['value'];
  children: ReactNode;
}) {
  return (
    <PluginWorkbenchContext value={workbench}>
      <DesktopShellStoreProvider store={store}>
        <ConversationOpenerContext value={opener}>{children}</ConversationOpenerContext>
      </DesktopShellStoreProvider>
    </PluginWorkbenchContext>
  );
}
